import styled from 'styled-components';

export const ContainerProviders = styled.div`
  display: flex;
  flex-direction: column;

  gap: ${({ theme }) => theme.spacing[4]}px;
  max-width: 440px;
`;

export const ContainerDetalhesProviders = styled.div`
  display: flex;
  flex-direction: column;

  gap: ${({ theme }) => theme.spacing[2]}px;
`;

export const ContainerEscolhaProviders = styled.div`
  display: flex;
  flex-direction: column;

  gap: ${({ theme }) => theme.spacing[2]}px;
`;

export const ContainerImagemProdutoIncluso = styled.div<{
  $alturaImagem: number;
  $larguraImagem: number;
}>`
  display: flex;
  position: relative;
  height: ${({ $alturaImagem }) => $alturaImagem}px;
  width: ${({ $larguraImagem }) => $larguraImagem}px;
`;

export const ContainerImagemProdutoVariavel = styled.div<{
  $alturaImagem: number;
  $larguraImagem: number;
}>`
  display: flex;
  position: relative;

  height: ${({ $alturaImagem }) => $alturaImagem}px;
  width: ${({ $larguraImagem }) => $larguraImagem}px;
`;

export const BotaoEscolherProvider = styled.button`
  background: none;
  outline: none;
`;
